import Auth from './Auth'
import AuthAdmin from './AuthAdmin'
import AuthAccountant from './AuthAccountant'

export default {
  Auth,
  AuthAdmin,
  AuthAccountant
}